import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const PrReqDisApprove = () => {
   useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  


  const canView  = hasPermission("Purchase Requisition DisApproval List", "view");
  useEffect(() => {
    fetchData();
  }, [ approvalStatus]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/purchaseReq_diApproveReport");
      setData(response.data.prDisApproval);
      setFilteredData(response.data.prDisApproval);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter((item) =>
      String(item.pnumber || "").toLowerCase().includes(term) ||
      String(item.fld_branchcode || "").toLowerCase().includes(term)
    );

    setFilteredData(filtered);
  };

  // Pagination Logic
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Disapproved Purchase Requisition-List</h2>
          <Time />
        </section>


        
                {/* Add New Button */}
                <div className="add-new-container">
                  <Link to={`/inventory/purchasesreqdisapproved_print`} target="_blank">
                    <button className="add-new-btn">Print</button>
                  </Link>
                </div>

       
        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by PR No"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Data Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>PR No</th>
                <th>Branch</th>
                <th>Date</th>
                <th>Department</th>
                <th>H.O.D</th>
                <th>Indent Ref.</th>
                <th>Head Meterial</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                      <Link to={`/inventory/viewpr_disapp/${item.pnumber}`}>
                        {item.pnumber}
                      </Link>
                    </td>
                    <td>{item.fld_branchcode}</td>
                    <td>{new Date(item.fld_duedate).toLocaleDateString()}</td>
                    <td>{item.fld_dept}</td>
                    <td>{item.fld_hod}</td>
                    <td>{item.fld_inref}</td>
                    <td>{item.fld_headmet}</td>
                   

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

              {/* Pagination */}
              <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>
          <button onClick={() => paginate(1)} className={currentPage === 1 ? "active" : ""}>
            1
          </button>
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button
                    key={pageNumber}
                    onClick={() => paginate(pageNumber)}
                    className={currentPage === pageNumber ? "active" : ""}
                  >
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}
          >
            Next
          </button>
        </div>

      </div>
    </div>
  );
};

export default PrReqDisApprove;
